import api from 'config/axios';
import AppService from 'common/app-service';

export default class PushSubscriptionsService extends AppService {
  constructor() {
    super('push-subscriptions', api);
  }

  async upsert(endpoint: string, p256dh: string, auth: string, carrierRootId?: number | null): Promise<void> {
    // Pass as pre-serialized string to prevent the axios camelToSnakeCase interceptor from
    // mangling p256dh → p_256_dh (lodash snakeCase splits on digit boundaries).
    const payload: Record<string, unknown> = { endpoint, p256dh, auth };
    if (carrierRootId != null) {
      payload.carrier_root_id = carrierRootId;
    }
    await this.api.post(this.servicePath, JSON.stringify(payload), {
      headers: { 'Content-Type': 'application/json' },
    });
  }

  async remove(endpoint: string, carrierRootId?: number | null): Promise<void> {
    const payload: Record<string, unknown> = { endpoint };
    if (carrierRootId != null) {
      payload.carrier_root_id = carrierRootId;
    }
    await this.api.delete(this.servicePath, { data: payload });
  }
}
